module.exports = __webpack_public_path__ + "img/multi_image03.a1ba7a6c.png";